// the assumed timezone for timestamps from the MRTM API
export const TIMEZONE = "Australia/Sydney";
